import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import firebase from 'firebase/app'
import "firebase/auth";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/weather-api',
      name: 'weatherImport',
      component: () => import(/* webpackChunkName: "about" */ './views/Weather-API.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/weather-class',
      name: 'weatherHistogramClass',
      component: () => import('./views/Weather-Histogram-Class.vue'),
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // check authorization
  if (to.matched.some(rec => rec.meta.requiresAuth)) {
    // check user state
    let user = firebase.auth().currentUser
    if (user) {
      next()
    } else {
      next({ name: 'Scrollitelling' })
    }
  } else { 
    next()
  }
})

export default router;
